/* eslint-disable react/jsx-fragments */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Header, Icon, Popup, Button, Divider } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Api, FundComparison } from 'actions';
import { colors } from 'utils/colors';
import { isGlobeInvestor } from 'utils/helpers';
import Bar from './Bar';
import { AiInsights } from '../../../../../Portfolio/Analytics/components';

class Holdings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tickerExchanges: {},
    };
  }

  componentWillMount() {
    const { holdings, dispatch } = this.props;
    const tickers_string = holdings
      .filter((item) => item.name !== 'GIC')
      .map((item) => item.ticker)
      .join(',');
    dispatch(
      Api.request('get', '/security/', {
        query: `?symbols=${tickers_string}`,
      })
    ).then((result) => {
      this.setState({ tickerExchanges: result });
    });
  }

  getExchangeSymbol(ticker, tickerExchanges) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < tickerExchanges.length; i++) {
      if (tickerExchanges[i].ticker === ticker) {
        return tickerExchanges[i].exchange_symbol;
      }
    }
    return '';
  }

  isExecuteVisible = (portfolio) => {
    const { partnerName } = this.props;
    if (!portfolio) {
      return false;
    }
    if (isGlobeInvestor(partnerName)) {
      return false;
    }
    if (
      portfolio.is_linked ||
      portfolio.portfolio_type === 'custom' ||
      portfolio.portfolio_type === 'quantified'
    ) {
      return false;
    }

    return true;
  };

  handleClick = (to) => {
    const { history } = this.props;

    if (to) {
      return history.push(to);
    }

    return false;
  };

  isLinked = (port) => {
    if (!port) {
      return false;
    }

    if (
      port.portfolio_type === 'custom' ||
      port.portfolio_type === 'quantified'
    ) {
      return true;
    }

    return port.is_linked;
  };

  render() {
    const {
      dispatch,
      holdings,
      portfolio,
      hasExcludedHolding,
      match,
      history,
      partnerName,
      id,
      replacements,
    } = this.props;
    const { tickerExchanges } = this.state;
    return (
      <Container>
        <Header size="medium" style={{ position: 'relative' }}>
          {'Portfolio Overview'}
          {this.isExecuteVisible(portfolio) && (
            <ETFButton
              style={{
                position: 'absolute',
                top: '0',
                right: '175px',
                fontSize: '0.85em',
                padding: '0.35em 1.3em',
                fontWeight: '400',
              }}
              onClick={() => {
                dispatch(FundComparison.clearExecute());

                this.handleClick(`/portfolio/${id}/execute`);
              }}
            >
              View ETFs
            </ETFButton>
          )}
          <div
            style={{
              position: 'absolute',
              top: '0',
              right: !this.isLinked(portfolio) ? '0' : '170px',
            }}
          >
            <AiInsights portfolio={portfolio} />
          </div>
          {!this.isLinked(portfolio) ? null : (
            <Popup
              trigger={
                <Button
                  active
                  basic
                  icon
                  labelPosition="right"
                  style={{
                    position: 'absolute',
                    top: '0',
                    right: '0',
                    fontSize: '0.85em',
                    padding: '0.35em',
                  }}
                >
                  Guidelines
                  <Icon
                    name="info circle"
                    style={{
                      fontSize: '15px',
                      verticalAlign: 'initial',
                      color: 'dimgrey',
                    }}
                  />
                </Button>
              }
              hoverable
              position="top center"
              style={{ maxWidth: '650px' }}
            >
              <Popup.Content>
                To protect the integrity of the statistical analysis,
                Wealthscope implements the following rules when analyzing your
                portfolio:
                <br />
                <br />
                If all of the securities in the portfolio have more than or
                equal to 48 months of history, all of the analysis will be
                performed. Otherwise, we exclude the following securities:
                <br />
                <ul>
                  <li>securities that have less than 36 months of history;</li>
                  <li>
                    securities that have between 36 and 47 months of history and
                    collectively weigh less than 10% of the portfolio.
                  </li>
                </ul>
                For securities included in the analysis, the period of analysis
                will be the longest common history.
                <br />
                <br />
                If all of the securities in the portfolio have less than 36
                months of history, we provide only basic summary information for
                the portfolio using the longest common history.
                <br />
                <br />
                If a passive ETF has insufficient history but there is a close
                substitute, the latter will be used in the analysis. For certain
                passive ETFs and CDRs with short history, we may use the index
                total return (minus the MER) prior to inception. See the list{' '}
                <a
                  href="https://docs.google.com/spreadsheets/d/1nJP1KzqxpDQYwaIX_LX-4TTiS-0AL7so/edit?usp=sharing&ouid=113159414220847142502&rtpof=true&sd=true"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  here
                </a>
                .
                <br />
                <br />
                Securities listed outside of outside of U.S. will not be
                included in the analysis.
                <br />
              </Popup.Content>
            </Popup>
          )}
          {portfolio.account && Object.keys(portfolio.account).length ? (
            <Header.Subheader style={{ transform: 'translateY(5px)' }}>
              {portfolio.account.user_institution ===
              'Overview; All Accounts' ? (
                <React.Fragment>
                  Overview <br />
                  All Accounts
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {portfolio.account.user_institution ? (
                    <Value
                      className={
                        portfolio.account.user_institution &&
                        portfolio.account.user_institution.length > 35
                          ? 'long'
                          : ''
                      }
                    >
                      {portfolio.account.user_institution}
                    </Value>
                  ) : null}
                  <br />
                  {portfolio.account.label}
                </React.Fragment>
              )}
            </Header.Subheader>
          ) : portfolio.name ? (
            <Header.Subheader style={{ transform: 'translateY(5px)' }}>
              {portfolio.name}
              {portfolio.description ? (
                <div>{portfolio.description}</div>
              ) : null}
            </Header.Subheader>
          ) : null}
        </Header>

        <Divider
          style={{
            margin:
              !isGlobeInvestor(partnerName) &&
              ((!portfolio.name && !portfolio.description) ||
                !portfolio.account)
                ? '12px 0 12px 0'
                : '12px 0',
          }}
        />

        <Wrapper limitHeight={holdings.length > 8}>
          {holdings.map((val) => (
            <Bar
              key={val.ticker}
              ticker={this.isLinked(portfolio) ? val.ticker : ''}
              name={this.isLinked(portfolio) ? val.name : val.wsName}
              exchange_symbol={this.getExchangeSymbol(
                val.ticker,
                tickerExchanges
              )}
              weight={val.weight}
              error={val.isExcluded}
              replaced={val.replacedBy}
              dispatch={dispatch}
              id={match.params.id || 'unsaved'}
              history={history}
              isReplacement={replacements.includes(val.ticker)}
            />
          ))}
        </Wrapper>
        {hasExcludedHolding ? (
          <p style={{ color: colors.hintRed, fontSize: '1rem' }}>
            Please check if any of your holdings have been excluded from the
            analysis. See "Guidelines" above for our rules. To use all of your
            holdings, use the toggle at the top, or the ‘Replace’ function
            (double red arrow icon) next to the holding(s).
          </p>
        ) : null}
      </Container>
    );
  }
}

Holdings.propTypes = {
  portfolio: PropTypes.object.isRequired,
  holdings: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  hasExcludedHolding: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  partnerName: PropTypes.string,
  id: PropTypes.string.isRequired,
  replacements: PropTypes.array,
};

Holdings.defaultProps = {
  partnerName: '',
  replacements: [],
};

export default connect((state) => ({
  partnerName: state.Storage['partner-name'],
  replacements: state.Analytics.data.paramsPassed.replacements || [],
}))(Holdings);

const Container = styled.div`
  border-radius: 8px;
  width: 50%;
  background: white;
  margin-bottom: 50px;
`;

const Wrapper = styled.div`
  height: ${(props) => (props.limitHeight ? '430px' : 'auto')};
  overflow: auto;
`;

const ETFButton = styled(Button)`
  background-color: ${colors.teal} !important;
  color: rgba(0, 0, 0, 0.6) !important;
`;

const Value = styled.span`
  position: absolute;
  left: 0rem;
  text-overflow: ellipsis;
  text-align: left;
  max-width: 15rem;
  overflow: hidden;
  white-space: nowrap;
  transition: background 0.1s ease;
  z-index: 9999;
  &.long:hover {
    background: ${colors.orange};
    padding: 0 5px;
    color: rgba(0, 0, 0, 0.7);
    border-radius: 3px;
    width: auto;
    max-width: unset;
    white-space: normal;
    overflow: unset;
  }
`;
